import {Injectable} from '@angular/core';
import {ApiService, LOCALE_CONFIG} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class VariantsService {

    constructor(private api: ApiService) {
    }

    getGroupedList(locale: string = LOCALE_CONFIG.DEFAULT_LOCALE) {
        return this.api.get(`/admin/variants-grouped/${locale}`).pipe(map(({result}) => result));
    }

    getList(locale: string = LOCALE_CONFIG.DEFAULT_LOCALE) {
        return this.api.get(`/admin/variants/${locale}`).pipe(map(({result}) => result));
    }

    update(data) {
        return this.api.put('/admin/variants/en-EN', data).pipe(map(({result}) => result));
    }

    delete(variants) {
        return variants.length === 1
            ? this.api.delete('/admin/variant/' + variants[0]).pipe(map(response => response))
            : this.api.delete('/admin/variants/', variants).pipe(map(response => response));
    }

}



// WEBPACK FOOTER //
// ./src/app/pages-services/variants.service.ts